export const ANALYTICS_EVENTS = {
  blogAiAssistClicked: 'blog_ai_assist_clicked',
  blogArticleViewed: 'blog_article_viewed',
  blogArticleCompleted: 'blog_article_completed',
  blogCommentDeleted: 'blog_comment_deleted',
  blogCommentSubmissionFailed: 'blog_comment_submission_failed',
  blogCommentSubmitted: 'blog_comment_submitted',
  blogCopyAction: 'blog_copy_action',
  blogEngagedTimeReached: 'blog_engaged_time_reached',
  blogNewsletterStatusViewed: 'blog_newsletter_status_viewed',
  blogReactionClicked: 'blog_reaction_clicked',
  blogScrollDepthReached: 'blog_scroll_depth_reached',
  blogShareCompleted: 'blog_share_completed',
  blogShareRequested: 'blog_share_requested',
  blogTocHeadingSelected: 'blog_toc_heading_selected',
  blogTocToggled: 'blog_toc_toggled',
  newsletterCtaViewed: 'newsletter_cta_viewed',
  newsletterSignupConfirmed: 'newsletter_signup_confirmed',
  newsletterSignupFailed: 'newsletter_signup_failed',
  newsletterSignupSubmitted: 'newsletter_signup_submitted',
  newsletterSignupSucceeded: 'newsletter_signup_succeeded',
  siteSearchPerformed: 'site_search_performed',
  themeToggled: 'theme_toggled',
} as const
